import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminLogin from "./SoftwarePages/AdminLogin";
import BranchLogin from "./SoftwarePages/BranchLogin";
import StaffLogin from "./SoftwarePages/StaffLogin";
import VendorLogin from "./SoftwarePages/VendorLogin";
import BillingLogin from "./SoftwarePages/BillingLogin";
import Index from "./Maindashboard/Pages/Index";
import InventoryPage from "./Maindashboard/inventory/InventoryPage";
import StockAlerts from "./Maindashboard/inventory/StockAlerts";
import InwardHistory from "./Maindashboard/inventory/InwardHistory";
import PayrollAttendance from "./Maindashboard/PayrollManagement/PayrollAttendance";
import PaySlips from "./Maindashboard/PayrollManagement/PaySlips";
import SalaryProcessing from "./Maindashboard/PayrollManagement/SalaryProcessing";
import Invoices from "./Maindashboard/BillingGst/Invoices";
import GSTReports from "./Maindashboard/BillingGst/GSTReports";
import Payments from "./Maindashboard/BillingGst/Payments";
import FinanceReports from "./Maindashboard/Reports/FinanceReports";
import SalesReports from "./Maindashboard/Reports/SalesReports";
import OperationalKPIs from "./Maindashboard/Reports/OperationalKPIs";
import Partners from "./Maindashboard/Partners/Partners";
import PartnerCommissions from "./Maindashboard/Partners/PartnerCommissions";
import UserPermissions from "./Maindashboard/AccessRole/UserPermissions";
import Branches from "./Maindashboard/Branches/Branches";
import BranchesReports from "./Maindashboard/Branches/BranchesReports";
import BranchOverview from "./Maindashboard/Branches/BranchOverview";
import RecipeManager from "./Maindashboard/Production/RecipeManager";
import ProductionRequest from "./Maindashboard/Production/ProductionRequest";
import ProductionBatches from "./Maindashboard/Production/ProductionBatches";
import RawMaterialUsage from "./Maindashboard/Production/RawMaterialUsage";
import WasteTracking from "./Maindashboard/Production/WasteTracking";
import SalesOrders from "./Maindashboard/crm/SalesOrders";
import Customers from "./Maindashboard/crm/Customers";
import QuotationComparison from "./Maindashboard/Partners/QuotationComparison";
import VendorTypes from "./Maindashboard/Partners/VendorTypes";
import VendorProfile from "./Maindashboard/Partners/VendorProfile";
import PurchaseOrderCreate from "./Maindashboard/Components/PurchaseOrderCreate";
import BranchToFactory from "./Maindashboard/Branches/BranchtoFactory";
import StockTransferTracking from "./Maindashboard/Branches/StockTransferTracking";
import MenuMaster from "./Maindashboard/Menu/MenuMaster";
import MenuMasterAdd from "./Maindashboard/Menu/MenuMasterAdd";
import MenuEdit from "./Maindashboard/Menu/MenuEdit";
import AllBills from "./Maindashboard/Menu/AllBills";
import BranchIndex from "./Branchdashboard/Pages/Index";
import BranchInventoryPage from "./Branchdashboard/inventory/InventoryPage";
import BranchStockAlerts from "./Branchdashboard/inventory/StockAlerts";
import BranchInwardHistory from "./Branchdashboard/inventory/InwardHistory";
import BranchPayrollAttendance from "./Branchdashboard/PayrollManagement/PayrollAttendance";
import BranchPaySlips from "./Branchdashboard/PayrollManagement/PaySlips";
import BranchSalaryProcessing from "./Branchdashboard/PayrollManagement/SalaryProcessing";
import BranchInvoices from "./Branchdashboard/BillingGst/Invoices";
import BranchGSTReports from "./Branchdashboard/BillingGst/GSTReports";
import BranchPayments from "./Branchdashboard/BillingGst/Payments";
import BranchFinanceReports from "./Branchdashboard/Reports/FinanceReports";
import BranchSalesReports from "./Branchdashboard/Reports/SalesReports";
import BranchOperationalKPIs from "./Branchdashboard/Reports/OperationalKPIs";
import BranchPartners from "./Branchdashboard/Partners/Partners";
import BranchPartnerCommissions from "./Branchdashboard/Partners/PartnerCommissions";
import BranchUserPermissions from "./Branchdashboard/AccessRole/UserPermissions";
import BranchBranchOverview from "./Branchdashboard/Branches/BranchOverview";
import BranchRecipeManager from "./Branchdashboard/Production/RecipeManager";
import BranchProductionRequest from "./Branchdashboard/Production/ProductionRequest";
import BranchProductionBatches from "./Branchdashboard/Production/ProductionBatches";
import BranchRawMaterialUsage from "./Branchdashboard/Production/RawMaterialUsage";
import BranchWasteTracking from "./Branchdashboard/Production/WasteTracking";
import BranchSalesOrders from "./Branchdashboard/crm/SalesOrders";
import BranchCustomers from "./Branchdashboard/crm/Customers";
import BranchQuotationComparison from "./Branchdashboard/Partners/QuotationComparison";
import BranchVendorTypes from "./Branchdashboard/Partners/VendorTypes";
import BranchVendorProfile from "./Branchdashboard/Partners/VendorProfile";
import BranchPurchaseOrderCreate from "./Branchdashboard/Components/PurchaseOrderCreate";
import BranchStockTransferTracking from "./Branchdashboard/Branches/StockTransferTracking";
import BranchMenuMaster from "./Branchdashboard/Menu/MenuMaster";
import BranchMenuMasterAdd from "./Branchdashboard/Menu/MenuMasterAdd";
import BranchMenuEdit from "./Branchdashboard/Menu/MenuEdit";
import BranchAllBills from "./Branchdashboard/Menu/AllBills";
import BillingPOS from "./BillingSystem/BillingPOS";
import VendorIndex from "./Vendordashboard/Pages/Index";
import VendorPurchaseOrders from "./Vendordashboard/Components/PurchaseOrderCreate";
import VendorDeliveries from "./Vendordashboard/Components/VendorDeliveries";
import VendorInvoices from "./Vendordashboard/Components/VendorInvoices";
import VendorPaymentReports from "./Vendordashboard/Components/VendorPaymentReports";
import VendorPurchaseReports from "./Vendordashboard/Components/VendorPurchaseReports";
import YourVendorProfile from "./Vendordashboard/Components/VendorProfile";
import VendorSecurity from "./Vendordashboard/Components/VendorSecurity";
import ProtectedRoute from "./Maindashboard/Components/ProtectedRoute";
import Unauthorized from "./Maindashboard/Components/Unauthorized";
import ChartOfAccounts from "./Maindashboard/Accounting/ChartOfAccounts";
import JournalEntries from "./Maindashboard/Accounting/JournalEntries";
import GeneralLedger from "./Maindashboard/Accounting/GeneralLedger";
import ProfitLoss from "./Maindashboard/Accounting/ProfitLoss";
import BalanceSheet from "./Maindashboard/Accounting/BalanceSheet";
import CashBook from "./Maindashboard/Accounting/CashBook";
import BankBook from "./Maindashboard/Accounting/BankBook";
import Expenses from "./Maindashboard/Accounting/Expenses";
import Income from "./Maindashboard/Accounting/Income";
import TrialBalance from "./Maindashboard/Accounting/TrialBalance";
import POTracking from "./Maindashboard/Components/POTracking";
import Counters from "./Maindashboard/Branches/Counters";
import Roles from "./Maindashboard/AccessRole/Roles";

function AppWrapper() {
  return (
    <div className="text-white min-h-screen flex flex-col font-inter">
      <main className="flex-grow">
        <Routes>
          <Route path="/adminlogin" element={<AdminLogin />} />
          <Route path="/branchlogin" element={<BranchLogin />} />
          <Route path="/stafflogin" element={<StaffLogin />} />
          <Route path="/vendorlogin" element={<VendorLogin />} />
          <Route path="/billinglogin" element={<BillingLogin />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route
            path="/admindashboard"
            element={
              <ProtectedRoute>
                <Index />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/poc"
            element={
              <ProtectedRoute permission="purchase_orders.create">
                <PurchaseOrderCreate />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/menu-master"
            element={
              <ProtectedRoute permission="menu.view">
                <MenuMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/po/tracking"
            element={
              <ProtectedRoute permission="po.tracking">
                <POTracking />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/menu-master/add"
            element={
              <ProtectedRoute permission="menu.create">
                <MenuMasterAdd />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/menu-master/edit/:id"
            element={
              <ProtectedRoute permission="menu.create">
                <MenuMasterAdd />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/menu-master/bills"
            element={
              <ProtectedRoute permission="menu.bills">
                <AllBills />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/menu-master/edit/:id"
            element={
              <ProtectedRoute permission="menu.create">
                <MenuEdit />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/inventory"
            element={
              <ProtectedRoute permission="inventory.view">
                <InventoryPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/inventory/alerts"
            element={
              <ProtectedRoute permission="inventory.alerts">
                <StockAlerts />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/inventory/inward-history"
            element={
              <ProtectedRoute permission="inventory.movement">
                <InwardHistory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/payroll/payslips"
            element={
              <ProtectedRoute permission="payslips.view">
                <PaySlips />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/payroll/attendance"
            element={
              <ProtectedRoute permission="attendance.view">
                <PayrollAttendance />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/payroll/salary"
            element={
              <ProtectedRoute permission="salary.manage">
                <SalaryProcessing />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/billing/invoices"
            element={
              <ProtectedRoute permission="invoices.view">
                <Invoices />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/billing/gst"
            element={
              <ProtectedRoute permission="gst.reports">
                <GSTReports />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/billing/payments"
            element={
              <ProtectedRoute permission="payments.manage">
                <Payments />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/reports/sales"
            element={
              <ProtectedRoute permission="reports.sales">
                <SalesReports />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/reports/kpis"
            element={
              <ProtectedRoute permission="reports.kpi">
                <OperationalKPIs />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/reports/finance"
            element={
              <ProtectedRoute permission="reports.finance">
                <FinanceReports />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/vendors"
            element={
              <ProtectedRoute permission="vendors.view">
                <Partners />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/vendors/:id"
            element={
              <ProtectedRoute permission="vendors.view">
                <VendorProfile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/vendors/vendortypes"
            element={
              <ProtectedRoute permission="vendors.view">
                <VendorTypes />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/vendors/quotationscompare"
            element={
              <ProtectedRoute permission="vendor_quotations.view">
                <QuotationComparison />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/vendors/commissions"
            element={
              <ProtectedRoute permission="vendor_payments.manage">
                <PartnerCommissions />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/access/permissions"
            element={
              <ProtectedRoute permission="staff.manage">
                <UserPermissions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/access/roles"
            element={
              <ProtectedRoute permission="staff.manage">
                <Roles />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/branches"
            element={
              <ProtectedRoute permission="branches.view">
                <Branches />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/counters"
            element={
              <ProtectedRoute permission="counters.view">
                <Counters />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/branches/demands"
            element={
              <ProtectedRoute permission="branches.demands">
                <BranchToFactory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/branches/stocktransfer"
            element={
              <ProtectedRoute permission="branches.transfer">
                <StockTransferTracking />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/branches/reports"
            element={
              <ProtectedRoute permission="branches.reports">
                <BranchesReports />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/production/recipes"
            element={
              <ProtectedRoute permission="production.recipes">
                <RecipeManager />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/production/request"
            element={
              <ProtectedRoute permission="production.request">
                <ProductionRequest />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/production/batches"
            element={
              <ProtectedRoute permission="production.batches">
                <ProductionBatches />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/production/materials"
            element={
              <ProtectedRoute permission="production.raw_usage">
                <RawMaterialUsage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/production/waste"
            element={
              <ProtectedRoute permission="production.waste">
                <WasteTracking />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/sales/orders"
            element={
              <ProtectedRoute permission="orders.view">
                <SalesOrders />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/sales/customers"
            element={
              <ProtectedRoute permission="customers.view">
                <Customers />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admindashboard/branches/:branchId"
            element={
              <ProtectedRoute permission="branches.view">
                <BranchOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounting/chartofaccounts"
            element={
              <ProtectedRoute permission="accounting.coa">
                <ChartOfAccounts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounting/journal-entries"
            element={
              <ProtectedRoute permission="accounting.journal">
                <JournalEntries />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounting/general-ledger"
            element={
              <ProtectedRoute permission="accounting.ledger">
                <GeneralLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounting/profit-loss"
            element={
              <ProtectedRoute permission="accounting.profit_loss">
                <ProfitLoss />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounting/balance-sheet"
            element={
              <ProtectedRoute permission="accounting.balance_sheet">
                <BalanceSheet />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounting/cash-book"
            element={
              <ProtectedRoute permission="accounting.cash_book">
                <CashBook />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounting/bank-book"
            element={
              <ProtectedRoute permission="accounting.bank_book">
                <BankBook />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounting/expenses"
            element={
              <ProtectedRoute permission="accounting.expenses">
                <Expenses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounting/income"
            element={
              <ProtectedRoute permission="accounting.income">
                <Income />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindashboard/accounting/trial-balance"
            element={
              <ProtectedRoute permission="accounting.trial_balance">
                <TrialBalance />
              </ProtectedRoute>
            }
          />
          <Route path="/billingdashboard" element={<BillingPOS />} />
          <Route path="/vendordashboard" element={<VendorIndex />} />
          <Route
            path="/vendordashboard/purchase-orders"
            element={<VendorPurchaseOrders />}
          />
          <Route
            path="/vendordashboard/deliveries"
            element={<VendorDeliveries />}
          />
          <Route
            path="/vendordashboard/payments"
            element={<VendorInvoices />}
          />
          <Route
            path="/vendordashboard/reports/payments"
            element={<VendorPaymentReports />}
          />
          <Route
            path="/vendordashboard/reports/purchase"
            element={<VendorPurchaseReports />}
          />
          <Route
            path="/vendordashboard/profile"
            element={<YourVendorProfile />}
          />
          <Route
            path="/vendordashboard/security"
            element={<VendorSecurity />}
          />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
